import React, { useMemo, useState } from 'react';
import * as styles from './Research.module.scss';
const renderImage = image => {
  if (!image) {
    return null;
  }
  const {
    desktop,
    mobile,
    alt
  } = image;
  const fallback = desktop || mobile;
  if (!fallback) {
    return null;
  }
  return /*#__PURE__*/React.createElement("picture", null, desktop && /*#__PURE__*/React.createElement("source", {
    media: "(min-width: 810px)",
    srcSet: desktop
  }), mobile && /*#__PURE__*/React.createElement("source", {
    srcSet: mobile
  }), /*#__PURE__*/React.createElement("img", {
    className: styles.rootMediaImage,
    src: fallback,
    alt: alt || '',
    loading: "lazy"
  }));
};
const Research = ({
  heading,
  tabs = [],
  defaultActiveIndex = 0
}) => {
  const hasTabs = Array.isArray(tabs) && tabs.length > 0;
  const {
    0: activeIndex,
    1: setActiveIndex
  } = useState(() => {
    if (!hasTabs) {
      return 0;
    }
    if (defaultActiveIndex < 0) {
      return 0;
    }
    if (defaultActiveIndex >= tabs.length) {
      return tabs.length - 1;
    }
    return defaultActiveIndex;
  });
  if (!hasTabs) {
    return null;
  }
  const safeIndex = Math.min(Math.max(activeIndex, 0), tabs.length - 1);
  const activeTab = tabs[safeIndex] || {};
  const {
    title,
    heading: tabHeading,
    description,
    stats = [],
    buttons = [],
    caption,
    image
  } = activeTab;
  const tabCount = tabs.length;
  const ariaHeading = useMemo(() => {
    if (heading) {
      return heading.replace(/<[^>]*>?/gm, '');
    }
    return 'Research';
  }, [heading]);
  const handleTabClick = index => {
    setActiveIndex(index);
  };
  return /*#__PURE__*/React.createElement("section", {
    className: styles.root
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.rootContainer
  }, heading && /*#__PURE__*/React.createElement("h2", {
    className: styles.rootHeading,
    dangerouslySetInnerHTML: {
      __html: heading
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.rootTabsRow
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.rootTabs,
    role: "tablist",
    "aria-label": ariaHeading
  }, tabs.map(({
    label
  }, index) => {
    const isActive = index === safeIndex;
    return /*#__PURE__*/React.createElement("button", {
      key: label,
      type: "button",
      role: "tab",
      "aria-selected": isActive,
      className: `${styles.rootTab} ${isActive ? styles.rootTabActive : ''}`,
      onClick: () => handleTabClick(index)
    }, label);
  }))), /*#__PURE__*/React.createElement("div", {
    className: styles.rootContentWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.rootContent
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.rootMedia
  }, renderImage(image)), /*#__PURE__*/React.createElement("div", {
    className: styles.rootCopy
  }, title && /*#__PURE__*/React.createElement("p", {
    className: styles.rootTitle
  }, title), tabHeading && /*#__PURE__*/React.createElement("h3", {
    className: styles.rootSubheading,
    dangerouslySetInnerHTML: {
      __html: tabHeading
    }
  }), description && /*#__PURE__*/React.createElement("p", {
    className: styles.rootDescription,
    dangerouslySetInnerHTML: {
      __html: description
    }
  }), stats.length > 0 && /*#__PURE__*/React.createElement("div", {
    className: styles.rootStats
  }, stats.map(({
    value,
    description: statDescription
  }) => /*#__PURE__*/React.createElement("div", {
    key: `${value}-${statDescription || ''}`,
    className: styles.rootStat
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.rootStatValue
  }, value), statDescription && /*#__PURE__*/React.createElement("span", {
    className: styles.rootStatDescription
  }, statDescription)))), buttons.length > 0 && /*#__PURE__*/React.createElement("div", {
    className: styles.rootButtons
  }, buttons.map(({
    label,
    href,
    external
  }, index) => {
    const variantClass = index === 0 ? styles.rootButtonPrimary : styles.rootButtonSecondary;
    const rel = external ? 'noreferrer noopener' : undefined;
    const target = external ? '_blank' : undefined;
    if (!href) {
      return /*#__PURE__*/React.createElement("span", {
        key: `${label}-${index}`,
        className: `${styles.rootButton} ${variantClass}`
      }, label);
    }
    return /*#__PURE__*/React.createElement("a", {
      key: `${label}-${href}`,
      className: `${styles.rootButton} ${variantClass}`,
      href: href,
      rel: rel,
      target: target
    }, label);
  })), caption && /*#__PURE__*/React.createElement("p", {
    className: styles.rootCaption,
    dangerouslySetInnerHTML: {
      __html: caption
    }
  }))))));
};
export default Research;